import { PLACEMENT_ENUM } from '@umu/umu-design/es/components/Dropdown/interface';
import type { IMenuItemInfo } from '@umu/umu-design/es/components/Menu/interface';
import React, { useMemo, useState } from 'react';
import { MenuDrop } from '../menuDrawer/dropMenu';

export interface IPaginationEllipsisPagesPickerProps {
    /** 被省略区间内的页码（已排序） */
    pages: number[];
    currentPage: number;
    onPageSelect: (page: number) => void;
    /** 无可选页时（极少见）保留原「点 … 跳 ±10 页」行为 */
    onFallbackJump: () => void;
}

/**
 * 分页 … ：基于 MenuDrop（Dropdown + Menu list）展开被省略页码；无可选页时退化为一次 jump。
 */
export function PaginationEllipsisPagesPicker({
    pages,
    currentPage,
    onPageSelect,
    onFallbackJump,
}: IPaginationEllipsisPagesPickerProps) {
    const [open, setOpen] = useState(false);

    const list: IMenuItemInfo[] = useMemo(
        () =>
            pages.map((p) => ({
                key: String(p),
                title: String(p),
                className: p === currentPage ? 'is-current' : undefined,
            })),
        [pages, currentPage],
    );

    if (pages.length === 0) {
        return (
            <li className="page-item" onClick={onFallbackJump}>
                ...
            </li>
        );
    }

    return (
        <li className={`page-item umu-pagination-v2-ellipsis${open ? ' is-open' : ''}`}>
            <MenuDrop
                className="umu-pagination-v2-ellipsis-menudrop"
                list={list}
                trigger="click"
                placement={PLACEMENT_ENUM.BOTTOM_LEFT}
                overlayClassName="umu-pagination-v2-ellipsis-overlay"
                onVisibleChange={setOpen}
                onChange={(key) => {
                    const n = Number(key);
                    if (!Number.isNaN(n)) {
                        onPageSelect(n);
                    }
                }}
            >
                <button type="button" className="umu-pagination-v2-ellipsis-trigger">
                    ...
                </button>
            </MenuDrop>
        </li>
    );
}
